import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { generateClient } from 'aws-amplify/api';
import { ConversationUpdateType } from './dtos';
var ON_CONVERSATION_UPDATE = "\n  subscription OnConversationUpdate($conversationId: ID!) {\n    onConversationUpdate(conversationId: $conversationId) {\n      conversationId\n      type\n      timestamp\n      data\n    }\n  }\n";
export var MESSAGE_STREAMING_API = 'MESSAGE_STREAMING_API';
export var MessageStreamingApi = /*#__PURE__*/function () {
  function MessageStreamingApi(messageMapper) {
    _classCallCheck(this, MessageStreamingApi);

    this.messageMapper = messageMapper;
  }

  _createClass(MessageStreamingApi, [{
    key: "subscribeToConversation",
    value: function subscribeToConversation(conversationId, callbacks) {
      var _client$graphql$subsc,
          _client$graphql,
          _this = this;

      var client = generateClient();
      var subscription = (_client$graphql$subsc = (_client$graphql = client.graphql({
        query: ON_CONVERSATION_UPDATE,
        variables: {
          conversationId: conversationId
        }
      }) //@ts-expect-error: We know this returns an object with subscribe in v5, or AsyncIterable in v6+
      ).subscribe) === null || _client$graphql$subsc === void 0 ? void 0 : _client$graphql$subsc.call(_client$graphql, {
        next: function next(_ref) {
          var data = _ref.data;
          var update = data === null || data === void 0 ? void 0 : data.onConversationUpdate;
          if (!update) return;

          switch (update.type) {
            case ConversationUpdateType.TYPING_INDICATOR:
              {
                var typingData = JSON.parse(update.data);

                if (typingData.isTyping) {
                  var _callbacks$onTypingSt;

                  (_callbacks$onTypingSt = callbacks.onTypingStart) === null || _callbacks$onTypingSt === void 0 ? void 0 : _callbacks$onTypingSt.call(callbacks);
                } else {
                  var _callbacks$onTypingEn;

                  (_callbacks$onTypingEn = callbacks.onTypingEnd) === null || _callbacks$onTypingEn === void 0 ? void 0 : _callbacks$onTypingEn.call(callbacks);
                }

                break;
              }

            case ConversationUpdateType.MESSAGE_STREAM_CHUNK:
              {
                var chunkData = JSON.parse(update.data);
                var chunkContent = chunkData.contentDelta;
                callbacks.onChunk(chunkContent);
                break;
              }

            case ConversationUpdateType.MESSAGE_STREAM_DONE:
              {
                var _callbacks$onStreamDo;

                var doneData = JSON.parse(update.data);
                (_callbacks$onStreamDo = callbacks.onStreamDone) === null || _callbacks$onStreamDo === void 0 ? void 0 : _callbacks$onStreamDo.call(callbacks, {
                  content: doneData.content,
                  tokenUsage: doneData.tokenUsage,
                  finishReason: doneData.finishReason
                });
                break;
              }

            case ConversationUpdateType.MESSAGE_RECEIVED:
              {
                var msgData = JSON.parse(update.data);

                var messageResult = _this.messageMapper.toDomain({
                  id: msgData.id,
                  conversationId: msgData.conversationId,
                  role: msgData.role,
                  content: msgData.content,
                  data: msgData.data,
                  userId: msgData.userId,
                  modelId: msgData.modelId,
                  createdAt: msgData.createdAt,
                  tokenUsed: msgData.tokenUsed,
                  cost: msgData.cost
                });

                if (messageResult.isSuccess) {
                  callbacks.onComplete(messageResult.getValue());
                } else {
                  callbacks.onError(messageResult.error);
                }

                break;
              }

            case ConversationUpdateType.ERROR:
            case ConversationUpdateType.INSUFFICIENT_BALANCE:
              {
                var _errorData$code;

                var errorData = JSON.parse(update.data);
                var error = new Error(errorData.message);
                error.code = (_errorData$code = errorData.code) !== null && _errorData$code !== void 0 ? _errorData$code : update.type;
                callbacks.onError(error);
                break;
              }

            default:
              console.warn('Unknown update type:', update.type);
          }
        },
        error: function error(_error) {
          callbacks.onError(_error);
        }
      });
      return function () {
        if (subscription) {
          subscription.unsubscribe();
        }
      };
    }
  }]);

  return MessageStreamingApi;
}();